var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollabContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    fill: "#F2FCFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 105.5,
    height: 105.5,
    rx: 15.25,
    stroke: "#009996",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11704_5215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0357 53.5702C47.2351 53.5702 53.0714 47.7339 53.0714 40.5344C53.0714 47.7322 58.905 53.5674 66.1021 53.5702C58.905 53.5729 53.0714 59.4081 53.0714 66.6059C53.0714 59.4064 47.2351 53.5702 40.0357 53.5702C32.8363 53.5702 27 59.4064 27 66.6059L27 79.6416L40.0357 79.6416C47.2351 79.6416 53.0714 73.8053 53.0714 66.6059C53.0714 73.8053 58.9077 79.6416 66.1072 79.6416L79.1429 79.6416L79.1429 66.6059C79.1429 59.4082 73.3093 53.5729 66.1123 53.5702C73.3093 53.5674 79.1429 47.7322 79.1429 40.5344L79.1429 27.4987L66.1072 27.4987C58.9077 27.4987 53.0714 33.335 53.0714 40.5344C53.0714 33.335 47.2352 27.4987 40.0357 27.4987L27 27.4987L27 40.5344C27 47.7339 32.8363 53.5702 40.0357 53.5702Z",
    fill: "#009996"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11704_5215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(27 27.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabContent);
export default __webpack_public_path__ + "static/media/CollabContent.e7a0c3c21956328b759b6121ebe14572.svg";
export { ForwardRef as ReactComponent };